import React, { useEffect, useRef } from "react";

const PaperPlaneAnimation: React.FC = () => {
  const planeRef = useRef<SVGGElement>(null);
  const pathRef = useRef<SVGPathElement>(null);
  const trailRef = useRef<SVGPathElement>(null);

  useEffect(() => {
    const plane = planeRef.current;
    const path = pathRef.current;
    const trail = trailRef.current;
    if (!plane || !path || !trail) return;

    const pathLength = path.getTotalLength();
    trail.style.strokeDasharray = `${pathLength}`;
    trail.style.strokeDashoffset = `${pathLength}`;
    trail.style.opacity = "1";

    let progress = 0;
    let paused = false;
    const speed = 8;
    const pauseDuration = 4000;
    const fadeSteps = 60;

    const animate = () => {
      if (paused) return;
      progress += speed;

      if (progress >= pathLength) {
        paused = true;
        let fadeProgress = 0;

        const fade = () => {
          fadeProgress++;
          const newOpacity = 1 - fadeProgress / fadeSteps;
          trail.style.opacity = newOpacity.toString();

          if (fadeProgress < fadeSteps) {
            requestAnimationFrame(fade);
          } else {
            setTimeout(() => {
              trail.style.opacity = "1";
              progress = 0;
              trail.style.strokeDasharray = `${pathLength}`;
              trail.style.strokeDashoffset = `${pathLength}`;
              paused = false;
              requestAnimationFrame(animate);
            }, pauseDuration);
          }
        };

        fade();
        return;
      }

      const point = path.getPointAtLength(progress);
      const nextPoint = path.getPointAtLength(progress + 1);
      const angle =
        (Math.atan2(nextPoint.y - point.y, nextPoint.x - point.x) * 180) /
          Math.PI +
        22;

      plane.setAttribute(
        "transform",
        `translate(${point.x}, ${point.y - 18}) rotate(${angle})`
      );
      trail.style.strokeDashoffset = `${pathLength - progress}`;

      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <div className="relative w-full max-w-6xl mx-auto h-32 sm:h-36 md:h-40 overflow-visible">
      <svg
        viewBox="-100 20 1100 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ width: "100%", height: "100%" }}
      >
        {/* ✅ Trajectoire adoucie (moins de hauteur) */}
        <path
          ref={pathRef}
          d="M-100,120 C50,60 250,60 400,120 S750,200 900,120 S1150,60 1300,120"
          stroke="transparent"
          fill="none"
        />
        <path
          ref={trailRef}
          d="M-100,120 C50,60 250,60 400,120 S750,200 900,120 S1150,60 1300,120"
          stroke="#FAE810"
          strokeDasharray="5,5"
          fill="none"
          strokeWidth={2}
        />
        <g ref={planeRef}>
          <polygon
            fill="#d9dce7ff"
            points="-28.16 20.5 16.75 10.22 -22.35 26.1 -6.16 43.62 16.75 10.22 -42.48 7.58 -28.16 20.5"
          />
          <polygon
            fill="#b0b3beff"
            points="-22.35 26.1 -29.37 37.73 -28.16 20.5 16.75 10.22 -22.35 26.1"
          />
          <polygon
            fill="#8c8f96ff"
            points="-22.35 26.1 -29.43 37.71 -16 32.97 -22.35 26.1"
          />
        </g>
      </svg>
    </div>
  );
};

export default PaperPlaneAnimation;
